module.exports = __webpack_public_path__ + "img/five.bbbed966.png";